import React from 'react';
import SoundSettings from '../../../components/TwoDays/SoundSettings';

/** Ops Settings — 이 브라우저의 알림음 설정 */

const OpsSettings = () => (
  <div className='flex max-w-[880px] flex-col gap-6'>
    <h1 className='text-[28px] font-medium leading-[120%] tracking-[-0.01em] text-text-primary'>
      Settings
    </h1>
    <SoundSettings description='Plays once when a new handoff arrives in the Lead inbox.' />
  </div>
);

export default OpsSettings;
